import type { CustomIcon } from '@/components';
import { type CaseModel, type EntryModel, type FormModel, Model } from '@/models';


// eslint-disable-next-line no-shadow
export enum ArchiveType {
    CASE='case',
    ENTRY='entry' 
}

export class ArchiveModel extends Model {
  identifier: string;
  type: ArchiveType;
  label: string;
  icon: CustomIcon;
  archivedAt: Date;
  createdAt: Date;
  creatorName: string;
  creatorAvatar: string;

  caseItem?: CaseModel;
  entry?: EntryModel;
  constructor(data: ArchiveModel) {
    super();
    this.identifier = data.identifier;
    this.type = data.type;
    this.label = data.label;
    this.icon = data.icon;
    this.archivedAt = data.archivedAt;
    this.createdAt = data.createdAt;
    this.creatorName = data.creatorName;
    this.creatorAvatar = data.creatorAvatar;
    this.caseItem = data.caseItem;
    this.entry = data.entry;
  }

  static mapWithCase(caseModel: CaseModel) {
    return new ArchiveModel({
      identifier: caseModel.identifier,
      type: ArchiveType.CASE,
      label: caseModel.label,
      icon: { style: 'fas', icon: 'folder', color: `rgb(133, 198, 255)`},
      archivedAt: caseModel.updatedAt,
      createdAt: caseModel.createdAt,
      creatorName: caseModel.creatorNames,
      creatorAvatar: caseModel.creatorAvatar,
      caseItem: caseModel
    });
  }

  static mapWithEntry(entry: EntryModel, forms: FormModel[]) {
    return new ArchiveModel({
      identifier: entry.identifier,
      type: ArchiveType.ENTRY,
      label: forms?.find(form => form.identifier === entry.formIdentifier)?.title ?? '',
      icon: { style: 'fal', icon: 'file'},
      archivedAt: entry.updatedAt,
      createdAt: entry.createdAt,
      creatorName: entry.creatorNames,
      creatorAvatar: entry.creatorAvatar ?? '',
      entry
    });
  }
}
